import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "", as }) => {
  const Comp = motion[as || "div"];
  return (
    <Comp
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </Comp>
  );
};

export const Overline = ({ children }) => (
  <span className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.28em] font-semibold text-[#0B63F6]">
    <span className="h-px w-8 bg-gradient-to-r from-[#0B63F6] to-[#16C7E8]" />
    {children}
  </span>
);
